<template>
  <div>
    <!-- <v-btn
      color="primary"
      class="ma-2 mt-5 mb-5 title"
      dark
      outlined
      large
      rounded
      @click="dialog = true"
    >
      <v-icon left>mdi-plus</v-icon>{{$vuetify.lang.t("$vuetify.courseManagement.lectureStep.addLecture")}}
    </v-btn>-->

    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          large
          elevation="0"
          class="my-3 body-2 text-primary text-capitalize"
          color="white"
        >
          <v-icon left>mdi-plus</v-icon>
          {{
            $vuetify.lang.t('$vuetify.courseManagement.lectureStep.addLecture')
          }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="dialog_video = true">
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-video-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-light subtitle-2">{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.video')
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="dialog_youtube = true">
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-youtube</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-light subtitle-2">{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.youtube')
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="dialog_document = true">
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-file-document-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-light subtitle-2">{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.document')
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="dialog_image = true">
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-image-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-light subtitle-2">{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.photo')
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="dialog_ebook = true">
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-book-open-page-variant</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-light subtitle-2">{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.book')
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="dialog_url = true">
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-link-variant</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-light subtitle-2">{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.website')
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="dialog_attach = true">
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-paperclip</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-light subtitle-2">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.otherFiles'
              )
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="dialog_article = true">
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-format-float-left</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-light subtitle-2">{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.article')
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="dialog_exam = true">
          <v-list-item-icon class="mr-2">
            <v-icon small>mdi-format-annotation-plus</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-light subtitle-2">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.examination'
              )
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Document dialog -->
    <document-dialog
      :isOpen.sync="dialog_document"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- Video dialog -->
    <video-dialog
      :isOpen.sync="dialog_video"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- Youtube dialog -->
    <youtube-dialog
      :isOpen.sync="dialog_youtube"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- E-Book dialog -->
    <ebook-dialog
      :isOpen.sync="dialog_ebook"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- Other file dialog (attach dialog) -->
    <attach-dialog
      :isOpen.sync="dialog_attach"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- URL dialog -->
    <url-dialog
      :isOpen.sync="dialog_url"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- Article dialog -->
    <article-dialog
      :isOpen.sync="dialog_article"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- Images dialog -->
    <image-dialog
      :isOpen.sync="dialog_image"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- Exam dialog -->
    <add-exam-dialog
      :isOpen.sync="dialog_exam"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
      :courseId="courseId"
    />
  </div>
</template>
<script>
import documentDialog from '@/views/course/lectures/document.vue';
import imageDialog from '@/views/course/lectures/image.vue';
import ebookDialog from '@/views/course/lectures/ebook.vue';
import attachDialog from '@/views/course/lectures/otherfile.vue';
import urlDialog from '@/views/course/lectures/url.vue';
import articleDialog from '@/views/course/lectures/article.vue';
// import videoDialog from '@/views/course/lectures/video.vue';

import videoDialog from "@/views/course/lectures/video-AntMedia.vue";
import youtubeDialog from '@/views/course/lectures/youtube.vue';
import addExamDialog from '@/views/course/lectures/exam/addExamManagement.vue';
export default {
  props: {
    sectionId: {
      type: String,
    },
    lectures: {},
    lectureId: {},
    reload: {
      type: Function,
    },
    courseId: {
      type: String,
    },
  },
  components: {
    documentDialog,
    imageDialog,
    ebookDialog,
    attachDialog,
    urlDialog,
    articleDialog,
    videoDialog,
    youtubeDialog,
    addExamDialog,
  },
  data() {
    return {
      maxWidth: '40%',
      dialog: false,
      dialog_video: false,
      dialog_youtube: false,
      dialog_document: false,
      dialog_image: false,
      dialog_ebook: false,
      dialog_url: false,
      dialog_attach: false,
      dialog_article: false,
      dialog_exam: false,
      notifications: false,
      id: '',
      sound: true,
      widgets: false,
      // nameRules: [
      //   v => !!v || "Title is required",
      //   v => (v && v.length <= 50) || "Title must be less than 50 characters"
      // ],
      // fileRules: [v => !!v || "file is required"],
      // urlRules: [v => !!v || "file is required"]
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.reload();
      this.closeLectureDialog();
    },
    closeLectureDialog() {
      this.dialog_video = false;
      this.dialog_youtube = false;
      this.dialog_document = false;
      this.dialog_image = false;
      this.dialog_ebook = false;
      this.dialog_url = false;
      this.dialog_attach = false;
      this.dialog_article = false;
      this.dialog_exam = false;
    },
  },
  beforeMount() {
    if (window.screen.width < 600) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 600 && window.screen.width < 960) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 960 && window.screen.width < 1264) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 1264 && window.screen.width < 1904) {
      this.maxWidth = '40%';
    } else {
      this.maxWidth = '40%';
    }
  },
};
</script>
<style scoped>
.lecture-type-card {
  width: 100%;
  padding-bottom: 40%;
  padding-top: 40%;

  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.lecture-type-card:hover {
  transform: scale(1.15, 1.15);
  cursor: pointer;
}

.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.buttonTypeContent.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  width: 100%;
  padding-bottom: 50%; /* 1:1 Aspect Ratio */
  padding-top: 50%;
  /* border-radius: 50px; */
}
.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}
.colCenter {
  text-align: center;
}
.textField {
  width: 100%;
}
.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}
.iframeWeb {
  width: 100%;
  height: auto;
  /* overflow: hidden; */
}
.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  margin-top: 7%;
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
.divExplanFile {
  justify-content: flex-end;
}
.headExplan {
  color: red;
  font-size: 20px;
  font-weight: bold;
}
.labelExplan {
  text-align: justify;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
/* @media only screen and (max-width: 600px ){
  .col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
} */
</style>
